<!-- 微信公众号二维码 -->
<template>
    <el-dialog @close=close   :close-on-click-modal="false" :title="title" append-to-body :visible.sync="centerDialogVisible" width="20%" center>
        <div style="text-align: center;">
         <Qr :size="200" :text="text"></Qr>
        </div>  
        <span slot="footer" class="dialog-footer">
            <p style="margin-bottom: 0.1rem;color: red;">{{tipText}}</p>
            <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
            <!-- <el-button type="primary"  @click="centerDialogVisible = false">我已关注</el-button> -->
        </span>
    </el-dialog>
</template>

<script>
import Qr from "@/components/Qr.vue";
export default {
    props:{
        tipText:{
            type:String,
            default:'扫描上方二维码关注公众号'
        },
        title:{
            type:String,
            default:'关注公众号'
        }
    },
    components: {Qr},
    data() {
        return {
            centerDialogVisible:false,
            text:'',
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick(url) {
            this.text =  url
            this.centerDialogVisible = true
        },
        close() {
            this.$emit('closePopup')
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>